/**
 * Widoczność huba „Ads Wizard" (VP-188) na produkcji.
 *
 * Feature domyślnie żyje tylko na dev/localhost — na `app.viral.partners`
 * pozycja w sidebarze jest ukryta. Ten helper otwiera ją punktowo dla konta
 * super_admina i dla wypisanych testerów, żeby dało się przeklikać kreator na
 * realnym środowisku bez podnoszenia roli w bazie (CLAUDE.md §0).
 *
 * Jedno źródło prawdy — wzorzec z `shopify-access.ts` / `google-ads-access.ts`.
 * Po otwarciu feature'a dla wszystkich: usuń bramkę razem z `isProductionHost()`
 * w sidebarze.
 */

/** Konta dopuszczone do Ads Wizarda na produkcji poza rolą `super_admin`. */
export const ADS_WIZARD_TESTER_EMAILS: ReadonlySet<string> = new Set<string>([
  "adrian.gasek.99@gmail.com",
  "biuro@viral.partners",
  "dev@viral.partners",
]);

export type AdsWizardAccessUser = {
  role?: string | null;
  email?: string | null;
};

/** Czy user ma widzieć Ads Wizard także na hoście produkcyjnym. */
export function canAccessAdsWizardOnProduction(
  user: AdsWizardAccessUser | null | undefined
): boolean {
  if (!user) return false;
  if (user.role === "super_admin") return true;
  const email = (user.email ?? "").toLowerCase();
  return email.length > 0 && ADS_WIZARD_TESTER_EMAILS.has(email);
}
